<template>
  <div class="flex flex-col overflow-hidden flex-grow">
    <ProjectNavigation ref="project-navigation" :view="'list'"></ProjectNavigation>

    <PageModiTab :project-id="projectId" :magazine-id="magazineId" :page-position="pagePosition"
                 :market-id="marketId"></PageModiTab>


    <!-- list view header menu -->
    <div class="flex mb-2 gap-2 p-2 bg-trader-gray items-stretch text-center justify-center items-center">

      <input v-model="searchArticleNumber" data-ui="search-article-number"
             class="outline-0 border border-bg-trader-input-border border-header w-[200px]  shadow-inner-2 text-gray-500 p-2"
             placeholder="Nach Artikelnummer filtern">

      <!-- Purchaser filter -->
      <select v-model="filterPurchaser" data-ui="filter-purchaser"
              class="outline-0 border border-bg-trader-input-border border-header p-1 w-[200px]  shadow-inner-2 text-gray-500 mr-1">
        <option data-ui="purchaser0" :value="0">Alle Einkaufsbereiche</option>
        <option v-for="purchaser in purchaserData" :key="purchaser.id" :value="purchaser.id"
                :data-ui="'purchaser' + purchaser.id">
          {{ purchaser.teamIcon }} - {{ purchaser.name }}
        </option>
      </select>

      <!-- Add product button -->
      <button class="p-2 hover:bg-trader-blue hover:text-white  bg-trader-dark-gray" data-ui="place-product"
              @click="addProductToMarket">Produkt
        hinzufügen
      </button>

      <!-- Excel export button -->
      <button class="p-2 hover:bg-trader-blue hover:text-white  bg-trader-dark-gray" @click="openExport">Excel Export
      </button>

      <button class="p-2 hover:bg-trader-blue hover:text-white  bg-trader-dark-gray" @click="openImport">Excel Import
      </button>

      <!-- space -->
      <div class="flex-grow"></div>

      <!-- Save changes button -->
      <button class="p-2 cursor-pointer bg-trader-green hover:bg-trader-blue hover:text-white"
              @click="saveList" data-ui="button-list-view-save-page-changes">Änderungen speichern
      </button>

      <!-- Reset changes button -->
      <button class="p-2 cursor-pointer text-center bg-trader-red hover:bg-trader-blue hover:text-white"
              @click="resetChanges" data-ui="button-list-view-reset-page-changes">Änderungen zurücksetzen
      </button>
    </div>


    <div v-if="loaded" data-ui="list-table" class="overflow-auto">

      <table class="min-w-full divide-y divide-gray-200 dark:divide-trader-dark-gray list-view"
             data-ui="list-view-table">

        <thead class="bg-gray-200 sticky top-0 z-20">
        <tr>
          <th class="sticky left-0 z-20 bg-trader-dark-gray table-cell  pl-2 text-left text-sm font-medium text-gray-600 uppercase shadow flex  min-w-[1100px] p-2">
            <div class="flex">
              <div class="w-[80px] text-trader-xs">Action</div>
              <div class="w-[80px] text-trader-xs">Art. Nr</div>
              <div class="w-[80px] text-trader-xs">EKB</div>
              <div class="   flex flex-wrap text-trader-xs" v-for="list in lists" :key="list.idProductFormList"
                   :class="[ list.size == 0  ? 'flex-grow': '']"
                   :style="{ width: list.size + 'px' }">
                <div>{{ list.label }}</div>
              </div>
            </div>
          </th>
          <!--Markt teil -->
          <th v-if="markets !== []" v-for="market in markets" :key="market.marketId"
              @click="topProductsForMarket(market.marketId)"
              class="px-4 py-2 text-sm bg-trader-dark-gray font-medium hover:bg-trader-blue hover:text-white dark:hover:text-black  text-center text-trader-xs border-l border-trader-gray "
              :class="{ 'bg-trader-blue text-white': !market.isActive }"
              :style="{ minWidth: listMarketMainSize + 'px', }">

            <p class="uppercase">
              {{ market.marketName }}
            </p>
            <p>
              {{ market.marketTeams.reduce((sum, item) => sum + item.placeholderUsed, 0) }} von
              {{ market.marketTeams.reduce((sum, item) => sum + item.placeholderTotal, 0) }}
            </p>
            <i class="fa-solid fa-magnifying-glass-plus p-1 hover:bg-trader-blue hover:text-white"
               @click="openPagePreview(market.pageId, market.marketName) "></i>
            <!-- Vorschau zeigen icon--->
            <!--  <p v-for="product in productsOnMarket" v-if="product.marketId == market.marketId">{{product.count}} von {{market.placeholderCount}}</p>-->
          </th>
        </tr>
        </thead>

        <tbody class=" divide-y divide-gray-200 dark:divide-trader-dark-gray ">


        <tr v-for="product in (filterPurchaser !== 0 ? filteredProducts.filter(item => item.teamId === filterPurchaser) : filteredProducts)"
            :key="product.productId" :data-ui="'list-table-article-number-' + product.articleNumber"
            class="bg-trader-light-gray">
          <td class="sticky left-0 z-10 pl-2 text-sm text-gray-500 p-2 table-cell bg-trader-gray "
              :data-hightlight-key="key(product.productId)"
              :key="key(product.productId)"
              :class="{ 'bg-trader-red': productHighlighted[product.productId] || false }"
          >

            <div class=" flex w-full h-full items-center">

              <!-- Action buttons -->
              <div class="w-[80px] text-trader-xs">
                <button class="fa-solid fa-repeat p-1 hover:bg-trader-blue hover:text-white"
                        title="Artikel Austauschen"
                        @click="changeArticle(product.productId,product.articleNumber,product?.markets)"
                        data-ui="artikel-austauschen"></button>

                <button class="fa-solid fa-trash-can p-1 hover:bg-trader-blue hover:text-white"
                        title="Löscht diesen Artikel aus allen Märkten auf dieser Seite"
                        @click="deleteArticleForList(product.productId,product.articleNumber,product?.markets,'markets')"
                        data-ui="delete-all-article-markets-relations"></button>

                <button class=" fa-solid fa-eraser p-1 hover:bg-trader-blue hover:text-white"
                        title="Alle Artikel im gleichem Einkaufsbereich dieses Artikels von dieser Seite löschen"
                        @click="deleteArticleForList(product.productId,product.articleNumber,product?.markets,'purchaser', product.teamId, product.teamIcon )"
                        data-ui="delete-all-article-ekb-relations"></button>
              </div>

              <!-- Article number -->
              <div class="w-[80px] text-trader-xs" data-ui="column-article-number"> {{ product.articleNumber }}</div>

              <!-- purchaser icon with color -->
              <div class="w-[80px] text-trader-xs " data-ui="column-ekb">
                 <span v-if=" product.teamIcon != ''" class="rounded p-1" data-ui="column-ekb-icon"
                       :style="`background-color: #${product.teamColor}; color: ${getBackgroundColor(product.teamColor)}`">
                  {{ product.teamIcon }}
                 </span>
              </div>

              <!-- DEBUGGING
              <div>{{lists}}</div>
              -->
              <!-- product custom fields -->
              <div class="h-full text-trader-xs pr-1 flex items-stretch justify-center items-center"
                   :class="{'flex-grow' : list.size == 0}"
                   v-for="list in lists"
                   :key="list.idProductFormList"
                   :style="{ width: list.size + 'px' }" :data-ui="'column_' + list.label">


                <!-- TODO: Warum gibt es hier nur "get-field-value" können die werte auch geschrieben werden und reagiert die Liste dann auch richtig auf die Änderungen? -->
                <template v-for="customization in customizations.fieldTypes">
                  <component v-if="list.type === customization.key" :is="customization.component"></component>
                </template>

                <!-- Hmm... Ist das Template hier nötig? Geht das eventuell anders/besser? -->
                <template v-if="product.markets.length > 0">

                  <span :class="[ list.size == 0  ? 'flex-grow': '']"
                        :style="{ width: list.size + 'px' }" v-if="list.type === 'text'">
                          {{ product.markets[0].customFields.find(item => item.field === list.field)?.value }}
                  </span>

                  <input v-if="list.type === 'input'" :class="[ list.size == 0  ? 'flex-grow': '']"
                         :data-ui="'input_' + list.label"
                         :value="getFieldValue(product.productId, 0, list.field)"
                         @input="event => { setFieldValue(product.productId,0, list.field, event.target.value);}"
                         class="outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-gray-500">

                  <input v-if="list.type === 'checkbox'" type="checkbox" :data-ui="'checkbox_' + list.label"
                         @input="event => { setFieldValueAsBoolean(product.productId,0, list.field, event.target.checked);}"
                         :checked="getFieldValueAsBoolean(product.productId, 0, list.field)">


                  <textarea :class="[ list.size == 0  ? 'flex-grow': '']" :data-ui="'textarea_' + list.label"
                            :style="{ width: list.size + 'px' }" v-if="list.type === 'textarea'"
                            :value="getFieldValue(product.productId, 0, list.field)"
                            @input="event => { setFieldValue(product.productId, 0, list.field, event.target.value);}"
                            class="outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-gray-500">
                  </textarea>


                </template>

              </div>
            </div>
          </td>


          <!--Markt teil -->
          <td v-if="markets !== [] && marketId !== 0" v-for="(market, index) in markets" class="text-sm text-gray-500  "
              :class="{ 'bg-trader-red': productHighlighted[key(product.productId, market.marketId)] || false}"
              :data-hightlight-key="key(product.productId, market.marketId)"
              :key="key(product.productId, market.marketId)"
          >

            <div class="border-l dark:border-trader-dark-gray p-2">

              <div class="flex">
                <span class="text-trader w-[150px]">Belegt:</span>
                <input class="" type="checkbox" :data-ui="'checkbox-placed' + index"
                       @click="event => handleCheckboxClick(event, product.productId, market.marketId, product)"
                       :checked="isMarketChecked(product, market.marketId)">
              </div>

              <div v-for="(listMarket, index) in listMarketData" :key="listMarket.idProductFormListMarket">
                <div class="flex">

                  <!-- Label -->
                  <span class="text-trader-xxs" :style="{ width: listMarket.textSize + 'px' }">
                  {{ listMarket.label }}
                </span>

                  <!-- Input -->
                  <input v-if="listMarket.type ==='input'"
                         class="text-right w-full border border-trader-input-border shadow-inner-2 dark:text-white"
                         :style="isValueDifferent(getFieldValue(product.productId, market.marketId, listMarket.field), getFieldOriginalValue(product.productId, market.marketId, listMarket.field)) ? 'background-color: #ffeb3b;' : ''"
                         :data-ui="'input-listMarket' + index"
                         :value="getFieldValue(product.productId, market.marketId, listMarket.field)"
                         @input="event => { setFieldValue(product.productId, market.marketId, listMarket.field, event.target.value);}">

                  <!-- Checkbox -->
                  <input v-if="listMarket.type ==='checkbox'" type="checkbox"
                         :style="isValueDifferent(getFieldValue(product.productId, market.marketId, listMarket.field), getFieldOriginalValue(product.productId, market.marketId, listMarket.field)) ? 'box-shadow: 0 0 0 2px #ffeb3b;' : ''"
                         :data-ui="'checkbox-listMarket' + index"
                         class="bg-trader-light-gray"
                         :checked="getFieldValueAsBoolean(product.productId, market.marketId, listMarket.field)"
                         @input="event => { setFieldValueAsBoolean(product.productId, market.marketId, listMarket.field, event.target.checked);}">

                  <!-- Textarea -->
                  <textarea v-if="listMarket.type === 'textarea'"
                            :style="isValueDifferent(getFieldValue(product.productId, market.marketId, listMarket.field), getFieldOriginalValue(product.productId, market.marketId, listMarket.field)) ? 'background-color: #ffeb3b;' : ''"
                            :data-ui="'textarea-listMarket' + index"
                            :value="getFieldValue(product.productId, market.marketId, listMarket.field)"
                            class="border border-trader-input-border shadow-inner-2"
                            @input="event => { setFieldValue(product.productId, market.marketId, listMarket.field, event.target.value);}">
                  </textarea>

                  <!-- Custom components -->
                  <template v-for="customization in customizations.fieldTypes">
                    <component v-if="listMarket.type === customization.key" :is="customization.component"
                               :form-field="listMarket.field"
                               :product-data="products" :get-field-value="getFieldValue">
                    </component>
                  </template>

                  <!-- Custom components (duplicate - remove if not needed) -->
                  <template v-for="customization in customizations.fieldTypes">
                    <component v-if="listMarket.type === customization.key" :is="customization.component"
                               :form-field="listMarket.field"
                               :product-data="products" :get-field-value="getFieldValue">
                    </component>
                  </template>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>


<script setup>
import ExportExcel from '@/components/Dialogs/ExportExcel.vue';
import {computed, onMounted, ref, watch} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {gql} from '@apollo/client/core';
import apolloClient from '@/apolloClient';
import {eventBus} from '@/application/EventBus';
import ProjectNavigation from '@/components/ProjectNavigation/ProjectNavigation.vue';
import ChangeArticle from '@/components/Dialogs/ChangeArticle.vue';
import db from '@/application/db';
import {customizations} from '@/customizations/customizations';
import ShowPreview from '@/components/Preview/ShowPreview.vue';
import addProductToMarketModal from '@/components/Dialogs/AddProductToMarket.vue';
import ProductsCanNotBePlaced from '@/components/Dialogs/ProductsCanNotBePlaced.vue';
import ConfirmAction from '@/components/Dialogs/ConfirmAction.vue';
import {useStore} from "vuex";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import {reloadHighlights} from "../application/Highlighter.js";
import PageModiTab from "@/components/PageModiTab/PageModiTab.vue";
import Alert from "@/components/Dialogs/Alert.vue";
import ImportExcel from "@/components/Dialogs/ImportExcel.vue";
import {mutation, query} from "@/graphql";


const router = useRouter();
const route = useRoute();

const projectId = ref(0);
const magazineId = ref(0);
const pagePosition = ref(0);
const marketId = ref(0);
const marketList = ref([]);
const markets = ref([]);
const products = ref([]);
const formId = ref(0);
const lists = ref([]);
const listMarketData = ref([]);
const listMarketMainSize = ref(0);
const productsOnMarket = ref({});
const filterPurchaser = ref(0);
const purchaserData = ref([]);
const marketIds = ref([]);
const searchArticleNumber = ref('');

const loaded = ref(false);


const store = useStore();
const page = computed(() => store.state.page.page);
let values = {};
const productHighlighted = {};


const key = (...args) => '' + args.join('_');

const filteredProducts = computed(() => {
  return products.value.filter(product => product.articleNumber.includes(searchArticleNumber.value));
});


const onSuccess = () => {
  getPageList();
};

// checkif getFieldValue is not the same as getFieldValueAsBoolean getFieldOriginalValue
const isValueDifferent = (value, originalValue) => {
  if (value === undefined || value === null) {
    return false;
  }
  return value.toString() !== originalValue.toString();
};

//##### Modals #####//
const addProductToMarket = () => {
  eventBus.openModal(addProductToMarketModal);
  eventBus.setData({
    message: "Belegen Sie den Artikel auf den märkten auf den sie platziert werden sollen",
    title: "Produkt auf Markt platziert",
    magazineId: magazineId.value,
    pagePosition: pagePosition.value,
    marketId: marketId.value || 0,
    onSuccess: onSuccess,
    productCanNotBePlaced,
  });
};

const openExport = () => {
  eventBus.openModal(ExportExcel);
  eventBus.setData({
    magazineId: magazineId.value,
  });
};
const openImport = () => {
  eventBus.openModal(ImportExcel);
  eventBus.setData({
    title: "Excel Import",
    magazineId: magazineId.value,
  });
};

const productCanNotBePlaced = (marketIds, ArticleNumber) => {
  eventBus.openModal(ProductsCanNotBePlaced);
  eventBus.setData({
    message: "Der Artikel mit der Artikelnummer " + ArticleNumber + " konnte nicht auf den Märkten platziert werden. ",
    title: "Produkt konnte nicht auf dem Markt platziert werden",
    magazineId: magazineId.value,
    pagePosition: pagePosition.value,
    marketIds: marketIds,
  });
};

const successConfirmation = (marktId, articleNumber) => {
  eventBus.openModal(SuccessConfirmation);
  eventBus.setData({
    message: "Der Artikel mit der Artikelnummer " + articleNumber + " kann nicht auf diesen Markt platziert werden, da dieser bereits auf einer anderen Seite platziert ist.",
    title: "Produkt kann nicht platziert werden",
  });
};

const openPagePreview = (pageId, marketId) => {
  eventBus.openModal(ShowPreview, {
    pageId: pageId,
    quality: 3,
    marktNumber: marketId,
  }, {fullSize: true});
};

const changeArticle = (productId, articleNumber, markets) => {
  eventBus.openModal(ChangeArticle);
  eventBus.setData({
    magazineId: magazineId.value,
    pagePosition: pagePosition.value,
    markets: markets,
    articleNumber: articleNumber,
    productId: productId,
    onAccept: getPage,
  });
};

const deleteArticleForList = (productId, articleNumber, markets, type, teamId, teamIcon) => {
  let message = '';
  if (markets == 0 && type == 'purchaser') {
    message = `Möchten Sie wirklich den Einkaufsbereich " + teamIcon + " auf dieser Seite leeren? <br> Somit gibt es keine Artikel mehr in diesem Einkaufsbereich auf dieser Seite.`;
  } else {
    message = `Möchten Sie wirklich den Einkaufsbereich ${teamIcon} auf dieser Seite von allen Märkten leeren? <br> Somit gibt es keine Artikel mehr in diesem Einkaufsbereich auf dieser Seite.`;
  }
  eventBus.openModal(ConfirmAction);
  if (type === 'purchaser') {
    eventBus.setData({
      title: "Artikel löschen",
      message: message,
      onAccept: () => {
        clearPurchaserGroup(productId, teamId);
      }
    });
  } else if (type === 'markets') {
    eventBus.setData({
      title: "Artikel löschen",
      message: "Möchten Sie wirklich diesen Artikel aus allen Märkten von dieser Seite löschen?",
      onAccept: () => {
        deleteArticleFromAllMarkets(productId, articleNumber, markets);
      }
    });
  }
};

let originalProducts = [];
let lastMarketId = null;

function topProductsForMarket(marketId) {
  // Beim allerersten Aufruf: Originalprodukte speichern
  if (originalProducts.length === 0) {
    originalProducts = [...products.value]; // Nur einmal klonen
  }

  // Wenn gleiche MarketId nochmal kommt → Originalreihenfolge wiederherstellen
  if (lastMarketId === marketId) {
    products.value = [...originalProducts];
    lastMarketId = null;
    return;
  }

  // Ansonsten sortieren (aber von Originaldaten ausgehend!)
  products.value = [...originalProducts].sort((a, b) => {
    const aHasMarket = a.markets.some(m => m.marketId === marketId);
    const bHasMarket = b.markets.some(m => m.marketId === marketId);

    if (aHasMarket === bHasMarket) return 0;
    return aHasMarket ? -1 : 1;
  });

  lastMarketId = marketId;
}


const resetChanges = async () => {
  const magazineIdInt = parseInt(magazineId.value);
  const pagePositionInt = parseInt(pagePosition.value);
  products.value.forEach(item => {
    db.listViewChanges.where('magazineId').equals(magazineIdInt)
        .and(row => row.pagePosition === pagePositionInt)
        .and(row => row.productId === item.productId)
        .delete()
  });
  for (const key in productHighlighted) {
    const dom = document.querySelector(`[data-hightlight-key="${key}"]`);
    if (dom !== null) {
      dom.classList.remove('bg-trader-red');
    }
  }
  values = {};
  await reloadHighlights();
  getPage();
};

const getChangedData = async () => {
  const magazineIdInt = parseInt(magazineId.value);
  const pagePositionInt = parseInt(pagePosition.value);
  return db.listViewChanges.where('magazineId').equals(magazineIdInt).and(field => field.pagePosition === pagePositionInt).toArray();
};

const markAsHighlighted = async (productId) => {
  highlight.value[productId] = true;
  const products = await getListViewChangesData();
  products.forEach(product => {
    highlight.value[product.productId + '_' + product.marketId] = true;
  });
};

const saveList = async () => {
  const results = await getChangedData();
  const listViewFields = [];
  const products = [];

  const removedProducts = [];
  const placeProducts = [];
  results.forEach(item => {
    if (item.type === 'ACTION') {
      products.push({
        productId: item.productId,
        marketId: item.marketId,
        action: item.action,
        virtualId: item.virtualId,
        productPosition: item.productPosition
      });

      if (item.action === 'PLACE') {
        placeProducts.push({
          productId: item.productId,
          marketId: item.marketId
        });
      } else {
        removedProducts.push({
          productId: item.productId,
          marketId: item.marketId
        });
      }

    } else {
      listViewFields.push({
        productId: item.productId,
        marketId: item.marketId,
        key: item.key,
        value: item.value
      });
    }
  });

  const saveListViewInput = {
    magazineId: magazineId.value,
    pagePosition: pagePosition.value,
    products: products,
    listViewFields: listViewFields || [],
    removedProducts: removedProducts,
    placeProducts: placeProducts
  };

  try {
    const [data, err] = await mutation.saveListView(saveListViewInput)
    if (err) {
      console.error("Fehler beim Speichern der Liste: ", err);
    }

  } catch (error) {
    console.error("Daten konnten nicht geupdatet werden ", error);
  } finally {
    await getPageList();
    await resetChanges();
  }
};

const getProductFormListMarket = async () => {
  try {
    const response = await apolloClient.query({
      query: gql`
        query getProductFormListMarket($idProductForm: Int!) {
          getProductFormListMarket(idProductForm: $idProductForm) {
            idProductFormListMarket
            idProductForm
            label
            field
            mainSize
            textSize
            type
          }
        }
      `,
      variables: {
        idProductForm: formId.value
      }
    });

    listMarketData.value = response.data.getProductFormListMarket;
    listMarketMainSize.value = response.data.getProductFormListMarket[0].mainSize;
  } catch (error) {
    console.error("Fehler beim Abrufen der getProductFormListMarket:", error);
  }
};

const getFieldValueAsBoolean = (productId, marketId, fieldName) => {
  const val = getFieldValue(productId, marketId, fieldName);
  if (val === undefined || val === null) {
    return false;
  }

  if (val === true) {
    return true;
  } else if (val === 'true') {
    return true;
  } else if (val === 'yes') {
    return true;
  } else if (val === '1') {
    return true;
  } else if (val === 1) {
    return true;
  }
  return false;
};

const getFieldValue = (productId, marketId, fieldName) => {
  if (values[key(productId, marketId, fieldName)] !== undefined) {
    return values[key(productId, marketId, fieldName)];
  }

  const product = products.value.find(item => item.productId === productId);
  if (marketId == 0) {
    const val = product.markets[0].customFields.find(item => item.field === fieldName)?.value;
    values[key(productId, marketId, fieldName)] = val;
    return val;
  }

  const val = product.markets.find(item => item.marketId === marketId)?.customFields.find(item => item.field === fieldName)?.value;
  values[key(productId, marketId, fieldName)] = val;
  return val;
};
const originalValues = {};

const getFieldOriginalValue = (productId, marketId, fieldName) => {
  if (originalValues[key(productId, marketId, fieldName)] !== undefined) {
    return originalValues[key(productId, marketId, fieldName)];
  }

  const product = products.value.find(item => item.productId === productId);

  if (marketId == 0) {
    const originalVal = product.markets[0].customFields.find(item => item.field === fieldName)?.originalValue;
    originalValues[key(productId, marketId, fieldName)] = originalVal;
    return originalVal;
  }

  const originalVal = product.markets.find(item => item.marketId === marketId)?.customFields.find(item => item.field === fieldName)?.originalValue;
  originalValues[key(productId, marketId, fieldName)] = originalVal;
  return originalVal;
};

const setFieldValueAsBoolean = (productId, marketId, fieldName, value) => {
  return setProductData({
    productId: productId,
    marketId: marketId,
    fieldName: fieldName,
    type: "FIELD",
    value: value ? 'yes' : 'no'
  });
};

const setFieldValue = async (productId, marketId, fieldName, value) => {
  return setProductData({
    productId: productId,
    marketId: marketId,
    fieldName: fieldName,
    type: "FIELD",
    value: value
  });
};

const placeProductCheckbox = async (productId, marketId, value) => {
  return setProductData({
    productId: productId,
    marketId: marketId,
    type: "ACTION",
  }, {
    action: value ? 'PLACE' : 'REMOVE',
    virtualId: 0,
    productPosition: 1
  });
};

const setProductData = async (productData, updateData) => {
  const data = {
    projectId: parseInt(projectId.value),
    magazineId: parseInt(magazineId.value),
    pagePosition: parseInt(pagePosition.value),
    productId: parseInt(productData.productId),
    marketId: parseInt(productData.marketId),
    type: productData.type,
    key: productData.fieldName || productData.type,
    fieldName: productData.fieldName || productData.type,
  };
  const updateDefault = {
    value: productData.value || null,
  };
  const update = {
    ...updateDefault,
    ...updateData
  };

  if (data.type === "FIELD") {
    values[key(data.productId, data.marketId, data.fieldName)] = update.value;
  }

  await db.transaction('rw', db.listViewChanges, async () => {
    const existingField = await db.listViewChanges
        .where('magazineId').equals(data.magazineId)
        .and(field => field.pagePosition === data.pagePosition && field.productId === data.productId && field.key === data.key && field.marketId === data.marketId)
        .first();

    if (!existingField) {
      await db.listViewChanges.add({...data, ...update});
    } else {
      await db.listViewChanges.update(existingField.id, update);
    }
  }).catch(err => {
    console.error(err);
  });

  setHighlight(data.productId);
  setHighlight(data.productId, data.marketId);
  await reloadHighlights();
};

const selectShoppingSections = async () => {
  try {
    const {data} = await apolloClient.query({
      query: gql`
        query getPurchasers {
          getPurchasers {
            id
            name
            teamPosition
            teamIcon
            color
          }
        }
      `
    });
    purchaserData.value = data.getPurchasers;
  } catch (error) {
    console.error("Fehler beim Abrufen der ShoppingSections:", error.message);
  }
};


const deleteArticleFromAllMarkets = async (productId, articleNumber, markets) => {
  if (markets === 0) {
    marketIds.value.push(markets);
  } else {
    markets.forEach(market => {
      marketIds.value.push(market.marketId);
    });
  }

  try {
    await apolloClient.mutate({
      mutation: gql`
        mutation deleteArticleFromAllMarkets( $magazineId: Int!, $pagePosition: Int!, $productId: Int!, $marketIds: [Int!]!) {
          deleteArticleFromAllMarkets( magazineId: $magazineId, pagePosition: $pagePosition, productId: $productId, marketIds: $marketIds) {
            success
          }
        }
      `,
      variables: {
        magazineId: magazineId.value,
        pagePosition: pagePosition.value,
        productId: productId,
        marketIds: marketIds.value,
      }
    });

    //  await getPageList();
    eventBus.closeModal();
  } catch (e) {
    console.error(e);
  } finally {
    await getPage();
  }
};

const clearPurchaserGroup = async (productId, teamId) => {
  try {
    await apolloClient.mutate({
      mutation: gql`
        mutation clearPurchaserGroup($magazineId: Int!, $pagePosition: Int!, $productId: Int!, $teamId: Int!) {
          clearPurchaserGroup(magazineId: $magazineId, pagePosition: $pagePosition, productId: $productId, teamId: $teamId) {
            success
          }
        }
      `,
      variables: {
        magazineId: magazineId.value,
        pagePosition: pagePosition.value,
        productId: productId,
        teamId: teamId
      }
    });

    if (value.onAccept) {
      value.onAccept();
      getPage();
      eventBus.closeModal();
    }
  } catch (e) {
    console.error(e);
  } finally {
    await getPage();
  }
};

const isMarketChecked = (product, marketId) => {


  if (values[key(product.productId, marketId, 'placed')] !== undefined) {
    return values[key(product.productId, marketId, 'placed')];
  }
  return product.markets.some(market => market.marketId === marketId);
};

const handleCheckboxClick = async (event, productId, marketId, product) => {

  const place = event.target.checked;

  if (event.target.checked) {
    const used = markets.value.find(market => market.marketId === marketId)?.marketTeams.find(team => team.teamId === product.teamId)?.placeholderUsed || 0;
    const total = markets.value.find(market => market.marketId === marketId)?.marketTeams.find(team => team.teamId === product.teamId)?.placeholderTotal || 0;

    if (used >= total) {
      event.target.checked = false;

      eventBus.openModal(Alert);
      const marketName = markets.value.find(market => market.marketId === marketId).marketName;
      if (marketId > 0) {
        eventBus.setData({
          message: "Der Artikel " + product.articleNumber + " konnte nicht auf den Markt " + marketName + " platziert werden, da der Einkaufsbereich " + product.teamIcon + " bereits voll ist.",
          title: "Produkt konnte nicht auf dem Markt platziert werden",
        });
      } else {
        eventBus.setData({
          message: "Der Artikel " + product.articleNumber + " konnte nicht auf der Seite platziert werden, da der Einkaufsbereich " + product.teamIcon + " bereits voll ist.",
          title: "Produkt konnte nicht auf der Seite platziert werden",
        });
      }
      return;
    }
  }


  const success = await checkIfProductIsOnMarket(productId, marketId, product, event.target.checked);
  if (success) {


    //markets.value.find(market => market.marketId === marketId).marketTeams.find(team => team.teamId === product.placedOnTeamId).placeholderUsed += event.target.checked ? 1 : -1;
    const marketTeams = markets.value.find(market => market.marketId === marketId).marketTeams;

    //update placeholderUsed for the team if the product is placed or removed from the market
    const removeTeam = marketTeams.find(team => team.teamId === product?.placedOnTeamId);
    const placeTeam = marketTeams.find(team => team.teamId === product?.teamId);
    if (place && placeTeam !== undefined) {
      placeTeam.placeholderUsed += 1;
    } else if (!place && removeTeam !== undefined) {
      removeTeam.placeholderUsed -= 1;
    }

  } else {
    event.target.checked = false;
  }
};

const checkIfProductIsOnMarket = async (productId, marketId, product, placeProduct) => {
  const newProduct = {
    productId: productId,
    marketId: marketId,
  };

  try {
    const mutation = gql`
      mutation checkIfProductIsOnMarket($productId: Int!, $marketId: Int!, $magazineId: Int!) {
        checkIfProductIsOnMarket(productId: $productId, marketId: $marketId, magazineId: $magazineId) {
          success
          code
          products {
            productId
            articleNumber
            placeholderPosition
            productPosition
            virtualId
          }
        }
      }
    `;

    const variables = {
      productId: productId,
      marketId: marketId,
      magazineId: magazineId.value,
    };
    const {data} = await apolloClient.mutate({mutation, variables});

    if (placeProduct) {
      if (data.checkIfProductIsOnMarket.code === "PLACEMENT_POSSIBLE") {
        placeProductCheckbox(productId, marketId, true);
      } else if (data.checkIfProductIsOnMarket.code === "PRODUCT_ALREADY_ON_MARKET") {
        successConfirmation(marketId, product.articleNumber);
        return false;
      } else {
        console.error("Fehler beim Platzieren des Produkts", data.checkIfProductIsOnMarket.code);
        return false;
      }
    } else {
      placeProductCheckbox(productId, marketId, false);
    }
  } catch (error) {
    console.error(error);
  }

  return true;
};

const getAction = (product, sourceProduct) => {
  setProductData({
    productId: sourceProduct.productId,
    marketId: sourceProduct.marketId,
    type: "ACTION",
  }, {
    action: product.action,
    virtualId: product.virtualId,
    productPosition: product.productPosition,
  });
};

const getProductListViewChanges = async () => {
  const magazineIdInt = parseInt(magazineId.value);
  const pagePositionInt = parseInt(pagePosition.value);

  const results = await db.listViewChanges.where('magazineId').equals(magazineIdInt).and(field => field.pagePosition === pagePositionInt).toArray();
  results.forEach(item => {
    if (item.type === 'field') {
      values[key(item.productId, item.marketId, item.key)] = item.value;
    }

    if (item.type === 'ACTION') {
      const place = item.action === 'PLACE';
      values[key(item.productId, item.marketId, 'placed')] = place;
      const product = products.value.find(product => product.productId === item.productId);
      const marketTeams = markets.value.find(market => market.marketId === item.marketId).marketTeams;

      //update placeholderUsed for the team if the product is placed or removed from the market
      const removeTeam = marketTeams.find(team => team.teamId === product?.placedOnTeamId);
      const placeTeam = marketTeams.find(team => team.teamId === product?.teamId);
      if (place && placeTeam !== undefined) {
        placeTeam.placeholderUsed += 1;
      } else if (!place && removeTeam !== undefined) {
        removeTeam.placeholderUsed -= 1;
      }

    }
  });
};

const getProductFormList = async () => {
  try {
    const response = await apolloClient.query({
      query: gql`
        query getProductFormList($idProductForm: Int!) {
          getProductFormList(idProductForm: $idProductForm) {
            idProductFormList
            idProductForm
            label
            field
            size
            type
          }
        }
      `,
      variables: {
        idProductForm: 1 //TODO: Dies ist hardcoded warum? War vorher auch so, gibt es dafür einen Grund?
      }
    });

    lists.value = response.data.getProductFormList;

  } catch (error) {
    console.error("Fehler beim Abrufen der getProductFormHeader:", error);
  }
};

const getFormNames = async () => {
  try {
    const response = await apolloClient.query({
      query: gql`
        query getFormularNames {
          getFormularNames {
            idForm
            name
            magazineType
          }
        }
      `
    });

    const formNames = response.data.getFormularNames;
    let f = null;
    formNames.forEach(item => {
      f = f === null && item.magazineType === 0 ? item.idForm : f;
      f = item.magazineType === page?.magazineTypeId ? item.idForm : f;
    });

    formId.value = f;
    await getProductFormList();
    await getProductFormListMarket();
  } catch (error) {
    console.error("Fehler beim Abrufen der getFormField:", error);
  }
};


const getPage = () => {
  loaded.value = false;
  getFormNames();
  getMarkets();
  getPageList();
  selectShoppingSections();
  loaded.value = true;
};

const getPageList = async () => {
  loaded.value = false;

  try {
    const [data, err] = await query.getPageList(magazineId.value, pagePosition.value, marketId.value);
    markets.value = (marketId.value != 0) ? data.markets : [];
    products.value = data.products;
    //load changes
    await getProductListViewChanges();

    loaded.value = true

  } catch (error) {
    console.error(error);
  }
};

const getMarkets = async () => {
  const query = gql`
    query getMarketsStatus($magazineId: Int!, $pagePosition: Int!) {
      getMarketsStatus(magazineId: $magazineId, pagePosition: $pagePosition) {
        marketId
        name
        description
        isActive
        isFull
      }
    }
  `;

  try {
    const {data} = await apolloClient.query({
      query,
      variables: {
        magazineId: magazineId.value,
        pagePosition: pagePosition.value
      }
    });

    marketList.value = data.getMarketsStatus;
  } catch (error) {
    console.error(error);
  }
};

const applyBetterThemeIfPossible = () => {
  try {
    document.querySelector(":has(body)");
    const styles = `
      .list-view tr input,
      .list-view tr textarea {
        border: 1px solid transparent !important;
        box-shadow: none !important;
        background: transparent;
        resize: none;

      }

      .list-view tr:hover{
        background: rgb(224, 224, 224);

      }

      .list-view input[type="checkbox"] {
        opacity: 0.2;
      }

      .list-view input[type="checkbox"]:checked {
        opacity: 1;
      }

      .list-view tr:has(input:focus) input,
      .list-view tr:has(input:focus) textarea,
      .list-view tr:hover input,
      .list-view tr:hover textarea {
        background: white;
        color: #333 !important;
        border: 1px solid rgb(160, 160, 160) !important;
        opacity: 1;
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
      }
    `;
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
  } catch (e) {
  }
};


const setHighlight = (...args) => {
  const k = key(...args);
  productHighlighted[k] = true;
  const dom = document.querySelector(`[data-hightlight-key="${k}"]`);
  if (dom !== null) {
    dom.classList.add('bg-trader-red');
  }
};


watch(() => route.params, (params) => {
      projectId.value = params.projectId || 0;
      magazineId.value = params.magazineId || 0;
      pagePosition.value = params.pagePosition || 0;
      marketId.value = params.marketId || 0;
      if (pagePosition.value != 0 && magazineId.value != 0) {
        getPage();
      } else {
        markets.value = [];
        products.value = [];
      }
    }, {immediate: true}
);

onMounted(async () => {
  if (magazineId.value !== 0 && pagePosition.value !== 0 && marketId.value !== 0) {
    getMarkets();
  }

  applyBetterThemeIfPossible();

  getChangedData().then((changes) => {
    for (const product of changes) {
      setHighlight(product.productId);
      setHighlight(product.productId, product.marketId);
      values[key(product.productId, product.marketId, product.key)] = product.value;
    }
    reloadHighlights();
  });

});


//TODO: auslagern in einer hilfs datei
const getBackgroundColor = (teamColor) => {
  const color = teamColor.startsWith('#') ? teamColor.substring(1) : teamColor;
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 125 ? '#000000' : '#FFFFFF';
};
</script>


<style>
.highlight {
  background-color: red;
}

</style>